/**
 * @file   知识检索
 * @create macaiqi 2021/11/26
 * @update
 */
// import React, { useEffect, useRef, useState, useCallback } from 'react';
import React, { useState, useEffect, useCallback } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { message } from 'antd';
import cls from 'classnames'
import { autoComplete } from '../../../shared/api'
import { GetQueryString } from '../../../../utils'
import './index.scss'
message.config({
  top: 200,
  duration: 1,
  maxCount: 1,
});
const SearchComponent = () => {
  const { search } = useLocation();
  const [autolist, setAutolist] = useState()
  const [showauto, setShowauto] = useState(false)
  const history = useHistory();
  const url = new URLSearchParams(search);
  const [keywords, setKeyword] = useState()
  useEffect(() => {
    setKeyword(GetQueryString('key'))
  }, [search])
  const handleKeyDown = useCallback(
    (e) => {
      if (e.charCode === 0 && e.keyCode === 13) {
        e.preventDefault();
        if (!keywords) {
          message.info({ content: '请输入关键词', icon: <i />, className: 'searchmessagetip', })
          return false;
        }

        setShowauto(false)
        history.push({
          pathname: '/KnowledgeSearch',
          search: `${'key=' + keywords}`
          // search: `${url.toString().includes('page') ? url.toString().split('page=')[0] + 'page=1' : 'key=' + (keywords)}`
        });

      }
    },
    [keywords, history]
  );
  const handClick = () => {
    if (!keywords) {
      message.info({ content: '请输入关键词', icon: <i />, className: 'searchmessagetip', })
      return false;
    }
    setShowauto(false)
    history.push({
      pathname: '/KnowledgeSearch',
      search: `${'key=' + keywords}`
    });
    // console.log(keywords)
  }
  const getAutolist = (val) => {
    setShowauto(true)
    autoComplete(val).then(res => {
      setAutolist(res)
    })
  }
  return (
    <div className="search">
      {/* {!pathname.includes('KnowledgeSearch') && <Link to='/' className="tohome">
        <i className='iconfont icon-shouyetianchong' />
      </Link>} */}
      <input type="text" name="" id="" value={keywords || ''} placeholder='请输入关键词，点击搜索按钮进行检索' onChange={(e) => {
        setKeyword(e.target.value);
        getAutolist(e.target.value)
      }} onKeyDown={handleKeyDown} />
      <i className='iconfont icon-sousuo-01' onClick={() => {
        handClick()
      }} />
      {autolist && <ul className={cls({ 'hide': !keywords || !showauto })}>
        {autolist?.map((item, index) => {
          return (
            <li className='autolist' key={index} onClick={() => {
              setKeyword(item)
              url.set('key', item || '');
              setShowauto(false)
              history.push({
                pathname: '/KnowledgeSearch',
                search: `${url.toString().includes('page') ? url.toString().split('page=')[0] + 'page=1' : 'key=' + (item)}`
              });
            }}>
              {item}
            </li>
          )
        })}
      </ul>}

    </div>
  )
}
export default SearchComponent;
